webpackJsonp([7495967469674],{

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rahman_img.81a60f71.png";

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FrontPage = function FrontPage() {
	    return _react2.default.createElement(
	        'div',
	        { style: {
	                margin: '0 auto',
	                width: '80%',
	                display: 'flex'
	
	            } },
	        _react2.default.createElement(
	            'div',
	            { className: 'info-text' },
	            _react2.default.createElement(
	                'h2',
	                { style: {
	                        color: '#B4BB2D',
	                        fontStyle: 'italic'
	                    } },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'quote' },
	                    '\u201C'
	                ),
	                ' Safe Skillful and Dependable'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                '  Dental Services Sami Rahman Oy was established in 2002 and since then has been located in Yliopistonkatu 31, in the center of Turku. In 2009 the company expanded to Parainen at Rantatie 24.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Our mission is to offer personal, painless and aesthetic dental care. Quality and friendly service is what we are renowned for. Over 30 years of experience guarantees a professional and proficient result for our patients. We provide general dental care by dentists and dental hygienists. Fear of a dentist is very common and understandable. We have a solid experience in dealing with fearful patients with great results. We welcome you to our practise, to begin a new, fearless, era in dental care..'
	            ),
	            _react2.default.createElement(
	                'h4',
	                { style: {
	                        color: '#B4BB2D',
	                        fontStyle: 'italic',
	                        marginLeft: '5%'
	                    }
	                },
	                'Take care of your dental health here \u2013 you will not be disappointed!'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'info-box' },
	                'CALL NOW FOR A BOOKING!',
	                _react2.default.createElement('br', null),
	                'Turku: (02) 233 5152',
	                _react2.default.createElement('br', null),
	                'Parainen: (02) 4585355'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'info-img' },
	            _react2.default.createElement('img', { src: __webpack_require__(52) })
	        )
	    );
	};
	
	exports.default = FrontPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-frontpage-js-2aab9fbd90cb7fb0422b.js